export const getScoresProps = (selection) => {
    // TODO: Integrate Results API
    return {
        scores: [
        // {
        //     type: "",
        //     first: "",
        //     second: ""
        // }
        ]
    };
};
//# sourceMappingURL=getScoresProps.js.map